<template>
  <v-container fluid>
    <h1 class="display-inline">
      KPI: Charge Rates
      <ContextHelp help-text="
There are two pieces of information needed to calculate the charge rates (aka Actual [Invoiced] Rates):
1. The total invoiced amount.
2. The actual time spent.

This information is collated at the task level and then aggregated to the job, job type, or service level.
For project managers, the charge rate is the same as for the job they manage.
For staff, the invoiced amount is the total invoiced for the job x the ratio of the job time they spent on the job

NOTE: Jobs with the 'finance exclude' flag set are excluded from the calculations.
NOTE: Task names are used to match between invoices and jobs
NOTE: Staff who have spent the most time on a job get the most benefit/penalty of the job going under/over budget as reflected
       in their effective charge rate.
"></ContextHelp>
    </h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <ReportChargeRatesGraph></ReportChargeRatesGraph>
  </v-container>
</template>

<script>
import ReportChargeRatesGraph from "@/components/reports/ReportChargeRatesGraph.vue"
import ContextHelp from "@/components/toolkit/ContextHelp.vue";
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "ReportChargeRatesPage",
  permissions: [...ReportChargeRatesGraph.permissions],
  components: {ActiveApiCalls, ContextHelp, ReportChargeRatesGraph},
  data() {
    return {}
  },
  mounted() {

  },
}

</script>

<style scoped>

</style>